// services/vehicle-repair.service.ts
import { Injectable } from '@angular/core';
import { from, lastValueFrom, Observable, of } from 'rxjs';
import { VehicleRepairData, VehicleRepairerGraphData } from '../models/vehicle-repair.model';
import { environment } from '../../environments/environment';
import { IQueryParameters } from '../models/api-base-actions.interface';
import { RestProvider } from './rest.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class VehicleRepairService {
  private baseApiUrl = environment.dataliveApiUrl;

  constructor(private rest: RestProvider){}

  // getVehicleRepairs(): Observable<VehicleRepairData[]> {
  //   const vehicleRepairData: VehicleRepairData[] = [
  //     {
  //       reg: 'DE73SLT',
  //       model: 'Ford eTransit',
  //       status: 'VOR',
  //       vorReason: 'Defect #10-678976',
  //       arrivedDate: '29/01/2024 1000',
  //       leaveDate: '04/02/2024 0500',
  //       daysAtRepairer: 7,
  //       notes: 'Engine needed replacing',
  //     },
  //     {
  //       reg: 'YG69LXS',
  //       model: 'MAN TGE',
  //       status: 'VOR',
  //       vorReason: 'Defect',
  //       arrivedDate: '29/01/2024 0500',
  //       leaveDate: '02/02/2024 0500',
  //       daysAtRepairer: 5,
  //       notes: '',
  //     },
  //     {
  //       reg: 'MAN TGE',
  //       model: '1',
  //       status: 'MOT',
  //       vorReason: '28/01/2024 1624',
  //       arrivedDate: '28/01/2024 1624',
  //       leaveDate: '01/02/2024 0500',
  //       daysAtRepairer: 4,
  //       notes: '',
  //     },
  //     {
  //       reg: 'YG69LXD',
  //       model: 'Mercedes Sprinter',
  //       status: 'VOR',
  //       vorReason: 'Defect #10-678965',
  //       arrivedDate: '27/01/2024 0835',
  //       leaveDate: '28/01/2024 0835',
  //       daysAtRepairer: 1,
  //       notes: '',
  //     },
  //     {
  //       reg: 'YG70TSV',
  //       model: 'Ford eTransit',
  //       status: 'VOR',
  //       vorReason: 'MOT',
  //       arrivedDate: '29/01/2024 0500',
  //       leaveDate: '31/01/2024 0500',
  //       daysAtRepairer: 2,
  //       notes: '',
  //     },
  //     {
  //       reg: 'DE73SLT',
  //       model: 'Ford eTransit',
  //       status: 'VOR',
  //       vorReason: 'Defect #10-678900',
  //       arrivedDate: '29/01/2024 1022',
  //       leaveDate: '29/01/2024 1022',
  //       daysAtRepairer: 1,
  //       notes: '',
  //     },
  //   ];
  //   return of(vehicleRepairData);
  // }

  getVehicleGraph(departmentId: string, regionId : string, depotId: string, _queryParams?: IQueryParameters): Observable<VehicleRepairerGraphData> {
    if( departmentId && regionId && depotId )
      _queryParams = {..._queryParams, 'department_id': departmentId, 'region_id': regionId, 'depot_id':depotId }
    const res = this.rest.get<VehicleRepairerGraphData>(`${this.baseApiUrl}/utilization/average_time_at_repairer_by_date/`, _queryParams ? _queryParams : undefined)
    return res
  }

  getVehicleRepairs(departmentId: string,regionId : string,depotId: string, _queryParams?: IQueryParameters): Observable<VehicleRepairData[]> {
    if( departmentId && regionId && depotId )
      _queryParams = {..._queryParams, 'department_id': departmentId, 'region_id': regionId, 'depot_id':depotId }
    const res = this.rest.get<VehicleRepairData[]>(`${this.baseApiUrl}/utilization/average_time_at_repairer/`, _queryParams ? _queryParams : undefined)
    return res
  }

}
